import React from "react";
import { Header, Label, Segment, Placeholder } from "semantic-ui-react";
import "./DetailsHeader.scss";

interface IDetailsHeader {
  permitsTypeName: string;
  formalNumber: string;
  formattedConfirmationNumber: string;
  status: string;
  isLoading: boolean;
  isSmallScreen: boolean;
}

export const DetailsHeader = ({
  permitsTypeName,
  formalNumber,
  formattedConfirmationNumber,
  status,
  isLoading,
  isSmallScreen,
}: IDetailsHeader) => {
  if (isLoading) {
    return (
      <Segment>
        <Placeholder fluid>
          <Placeholder.Header>
            <Placeholder.Line />
            <Placeholder.Line />
          </Placeholder.Header>
        </Placeholder>
      </Segment>
    );
  }
  return (
    <Segment className='details-header'>
      <div className='header-div'>
        <div className='details-name-and-number'>
          <Header as='h1'>
            <div className='permits-type-name'> {permitsTypeName}</div>
            <div className='app-id tw-mb-1'>{formalNumber || formattedConfirmationNumber}</div>
          </Header>
        </div>
      </div>
      {status == "on_hold" && (
        <Label style={{ marginBottom: 8 }} color='red' size={isSmallScreen ? "large" : "big"}>
          {" "}
          On Hold{" "}
        </Label>
      )}
    </Segment>
  );
};

export default DetailsHeader;
